import { render, staticRenderFns } from "./kateg.vue?vue&type=template&id=6a652796&scoped=true&"
import script from "./kateg.vue?vue&type=script&lang=js&"
export * from "./kateg.vue?vue&type=script&lang=js&"
import style0 from "./kateg.vue?vue&type=style&index=0&id=6a652796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a652796",
  null
  
)

export default component.exports